import React, { useState, useEffect } from 'react';
import { Select } from 'antd';
import { fetchActiveBatches } from "../../services/ide-apis";
import { global_var } from "../../services/cs-lab-config";

const { Option } = Select;

const BatchLoader = ({onChange, selectedBatch}) => {
    document.title = 'Batch Loader';
    const [batches, setBatches] = useState([]);
    const [loading, setLoading] = useState(false);
    const [debounceTimeout, setDebounceTimeout] = useState(null);


    useEffect(() => {
        if (selectedBatch && selectedBatch.length > 0) {
            setBatches(selectedBatch);
        }
    }, [selectedBatch]);

    const handleBatchSelect = (value, option) => {
        if (onChange && option && option.length > 0) {
            const dataToSend = option.map((opt) => {
                const convertedId = opt.data._id ? opt.data._id["$oid"] : opt.data.fkBatchId;
                const newData =  {
                    ...opt.data,
                    fkBatchId: convertedId || opt.data._id, // If "$oid" exists, use it; otherwise, use the original value
                };
                delete newData._id;
                return newData;
            });
            onChange(dataToSend);
        }
    };

    const handleSearchChange = (value) => {
        // Clear the existing timeout
        if (debounceTimeout) {
            clearTimeout(debounceTimeout);
        }

        // Set a new timeout to trigger the API call after 500 milliseconds of inactivity
        const timeout = setTimeout(() => {
            loadBatches();
        }, 500);

        setDebounceTimeout(timeout);
    };

        const loadBatches = async () => {
            try {
                setLoading(true);

                let batchObj = {
                    status: 'active',
                };

                if (global_var.parent_company_id) {
                    batchObj['childCompanyId'] = global_var.company_id;
                    batchObj['cmpId'] = global_var.parent_company_id;
                } else {
                    batchObj['cmpId'] = global_var.company_id;
                }

                let response = await fetchActiveBatches(batchObj);

                try {
                    let responseData = JSON.parse(response.data);
                    if (Array.isArray(responseData) && responseData.length > 0) {
                        if (selectedBatch && selectedBatch.length > 0) {
                            const updatedBatch = [...selectedBatch, ...responseData];
                            setBatches(updatedBatch);
                        }else{
                            setBatches(responseData);
                        }
                        setBatches(responseData);
                    } else {
                        setBatches([]);
                    }
                } catch (error) {
                    console.error('Error parsing JSON:', error);
                    setBatches([]);
                }
            } catch (error) {
                console.error('Error fetching batches:', error);
            } finally {
                setLoading(false);
            }
        };

    return (
        <div>
            <Select
                mode="multiple"
                placeholder="Select batches"
                style={{ width: '100%' }}
                onChange={handleBatchSelect}  
                onSearch={handleSearchChange} 
                optionLabelProp="label"
                showSearch
                filterOption={(input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                loading={loading}
                value={selectedBatch && selectedBatch.length > 0 ? selectedBatch.map(selecBatch => selecBatch.batchName) : undefined}
            >
                {batches.map((batch) => (
                    <Option key={batch.batchName} data={batch} value={batch.batchName} label={batch.batchName}>
                        {batch.batchName}
                    </Option>
                ))}
            </Select>
        </div>
    );
};

export default BatchLoader;
